import { Wording } from '@/types';

export const MEDITATION_WORDING_LT: Wording = {
  components_header_media_content: 'Garso įrašai',
  components_header_media_1: 'Meditacijos',
  components_header_media_2: 'Podcast\'as',
  components_header_text1: 'Vadovai',
  components_header_text2: 'Dienoraštis',
  components_header_members: 'nariai',
  hero_text: 'Kur meditacija susitinka su žvaigždėmis',
  hero_button_text: 'Pradėkite savo kelionę į vidų',
  components_ressources_section_title: 'IŠTEKLIAI',
  components_ressources_subheader_text: 'Vidinės ramybės, įžeminimo ir kasdienės pusiausvyros įrankiai',
  components_ressources_span_text: 'Atverkite duris į vidinę ramybę mūsų pačių pasirinktomis meditacijomis ir vadovais. Atraskite aiškumą, susisiekite su kvėpavimu ir susilygiuokite su savo vidiniu ritmu – vieną akimirką dėmesingai.',
  components_ressources_card_1_title: 'Atspindys',
  components_ressources_card_1_text: 'Trumpos meditacijos ir garso apmąstymai, skirti sutelkti mintis ir prisitaikyti prie kosminio ritmo.',
  components_ressources_card_2_title: 'Tyrinėkite gelmes',
  components_ressources_card_2_text: 'Keliaukite už paviršiaus su įtraukiančiais vadovais, kuriuose meditacija, astrologija ir savęs tyrinėjimas susilieja, siekdami ilgalaikių pokyčių.',
  components_ressources_link: 'Žiūrėti daugiau',
  components_notes_and_google_title_1: 'Sielingas vadovas',
  components_notes_and_google_title_2: 'Sąmoningi ritualai',
  components_notes_and_google_title_3: 'Vadovaujamos meditacijos',
  components_review_google_text: 'Google atsiliepimai',
  media_content_section_title: 'AUDIOS',
  media_content_section_subheader_text: 'Mūsų meditacijos',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Atraskite daugiau',
  text2_section_title: 'BLOGAS',
  text2_section_subheader_text: '',
  text2_section_button_more: '',
  components_text1_section_title: 'VADOVAI',
  components_text1_subheader_text: 'Kosminės žinios kasdieniam derinimui',
  components_text1_span_text: 'Susiderinkite su visatos ritmais: tyrinėkite kuruojamą išsamių astrologinių ir meditacinių vadovų kolekciją, skirtą pažadinti vidinį aiškumą, pagilinti savimonę ir palaikyti jūsų sielos, dangiško augimo kelionę.',
  components_text1_card_1_title: 'Atidarykite tylą',
  components_text1_card_1_text: 'Pradėkite savo kelionę nuo pagrindinių meditacijos ir astrologijos vadovų – idealiai tinka ieškantiems vidinės ramybės, kosminių modelių ir asmeninės įžvalgos.',
  components_text1_card_3_title: 'Proto ir kūno jungtis',
  components_text1_card_3_text: 'Atskleiskite gilesnius savo vidinio pasaulio sluoksnius. Šie vadovai peržengia paviršių, kad atskleistų prasmę, emocijas ir dėmesingus modelius, kurie formuoja jūsų patirtį.',
  components_text1_card_2_title: 'Atspindėti ir integruoti',
  components_text1_card_2_text: 'Nuo emocinių blokų iki planetų ciklų – šie vadovai siūlo įrankius apmąstymams, gydymui ir transformacijai per dėmesingus ritualus ir astrologinę išmintį.',
  components_text1_link: 'Peržiūrėti visus vadovus',
  components_footer_text: 'Pabusk viduje: tavo ramybė, tavo stiprybė',
  components_footer_info: 'Informacija',
  components_footer_registration_number: 'Registracijos numeris',
  components_footer_legal: 'Teisinė',
  components_footer_terms: 'Taisyklės ir sąlygos',
  components_footer_privacy: 'Privatumo politika',
  button_load_more: 'Įkelti daugiau',
  page_media_1_content_hero_text: 'Meditacijos',
  page_media_content_menu_antistress: 'Antistresas',
  page_media_content_menu_mindfulness: 'Sąmoningumas',
  page_media_content_menu_energyboost: 'Energy Boost',
  page_media_content_menu_mantra: 'Mantra',
  page_media_2_content_hero_text: '',
  page_text1_hero_text: 'Vadovai',
  page_text1_section_title: 'Vadovai',
  page_text1_subheader_text: 'Mūsų vadovai',
  page_text2_hero_text: '',
  page_text2_section_title: '',
  page_text2_subheader_text: '',
  enter_email_title: 'Norėdami tęsti, įveskite savo el. pašto adresą',
  enter_email_placeholder_email: 'El. paštas',
  enter_email_button_enter: 'Įeikite',
  components_login_success_text: 'Prisijungimas sėkmingas!',
  components_card_link_media_content: 'Klausyk dabar',
  components_card_link_text1_content: 'Žiūrėti vadovą',
  components_card_link_text2_content: 'Naršyti',
  france: 'Prancūzija',
  cyprus: 'Kipras',
  tag_podcast: 'Podcast\'as',
  tag_meditation: 'Meditacija',
  page_media_content_menu_all: 'Visi',
};